


















import { Component, Vue } from "vue-property-decorator";

import Button from "@/components/Button.vue";
import Card from "@/components/Card.vue";

@Component({
  components: {
    Card,
    Button,
  },
})
export default class Randomizer extends Vue {
  name = "random"
  items: Array<any> = []
  axios: any

  data() {
    return {
      items: [],
      buttonText: "Show me another random recipe!" // This is the random button
    }
  }
  /* Requests to get random items*/
  public getRandom() {
    const requestRandom = "/random.php";
    this.axios
      .get(requestRandom)
      .then(response => {
        this.items.push(response.data.meals[0])
    });
  }
  /* Display random items when categories component is loaded */
  created() {
    this.getRandom();
  }
  /* Function onClick "random" button */
  randomize() {
    this.items = [];
    this.getRandom();
  }
}

